import {
    doGetQCXRequest,
    doPostQCXRequest,
    doPutQCXActivateRequest,
    doPutQCXInactivateRequest,
    doPutQCXRequest,
  } from '../../utils/api/domain/domain-api-utils';
import { TARIFA_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
    return doGetQCXRequest([TARIFA_ENDPOINT]);
}
async function fetchById(id) {
    return doGetQCXRequest([
        TARIFA_ENDPOINT,
        id,
    ]);
}
async function register(data, queryParams = []) {
    return doPostQCXRequest(
        [TARIFA_ENDPOINT],
        data,
        queryParams
    );
}
async function save(data, queryParams = []) {
    return doPutQCXRequest(
        [TARIFA_ENDPOINT],
        data,
        queryParams
    );
}
async function activateById(id) {
    return doPutQCXActivateRequest(
        [TARIFA_ENDPOINT],
        id
    );
}
async function inactivateById(id) {
    return doPutQCXInactivateRequest(
        [TARIFA_ENDPOINT],
        id
    );
}

const tabelaFreteAPI = {
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
};

export {
    tabelaFreteAPI,
    fetchAll,
    fetchById,
    register,
    save,
    activateById,
    inactivateById,
  };
  